import React, { useEffect, useState } from "react";

import { toastMessage } from "utils/toastMessage";
import {  regex } from "utils/formValidator";
import {Input } from "common/InputForm";
import { addHastagApi } from "services/hashtag";
import { CustomModal } from "components/modals/ModalBox";
const AddHasTagManagement = ({
  setChangeHastag,
  changeHastag,
  hastagListHandler,
  type,
}) => {
  const [errors, setErrors] = useState({});
  const [inputData, setInputData] = useState({});
  const validation = () => {
    let status = true;
    const error = {};
  
    if (!inputData.name) {
      error["name"] = "Please enter name";
      status = false;
    }

    setErrors(error);
    return status;
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const addHastagHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      // setButtonLoader(true);
      try {
        const formData = new FormData();
        formData.append("title", inputData.name || "");
        if (inputData.iconPreview)
          formData.append("icon", inputData.icon);
        const res = await addHastagApi(formData);
        if (res?.data?.status === 200) {
          setChangeHastag(false);
          toastMessage(res?.data?.message, "success", "addHastagHandler");
          hastagListHandler();
          setInputData({});
          // navigate(-1);
        } else {
          toastMessage(res?.data?.message, "error", "addHastagHandler");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        // setButtonLoader(false);
      }
    }
  };


  return (
    <>
      <CustomModal
        show={changeHastag}
        handleClose={() => setChangeHastag(false)}
      >
        <h3>Add Hashtag</h3>
        <div className="form_field_wrap">
      
          <div className="form_field">
            <Input
              type="text"
              label="Name"
              placeholder="Enter name"
              value={inputData.name}
              onChange={onChangeHandler}
              name="name"
              id="name"
              error={errors.name}
            />
          </div>
        </div>
    
        <div className="button_wrap">
          <button
            type="button"
            className="button light"
            onClick={() => {
              setChangeHastag(false);
              setInputData({});
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            // ref={buttonLoaders}
            onClick={addHastagHandler}
            className="button"
          >
            Add
          </button>
        </div>
      </CustomModal>
    </>
  );
};
export default AddHasTagManagement;
